import { RecordMortgageInsuranceDisbursementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateRecordMortgageInsuranceDisbursement = makeValidator({
  FieldParser: RecordMortgageInsuranceDisbursementRow,
});
